import './App.css';

import { useEffect } from 'react';

import Chat from './components/Chat/Chat';
import Join from './components/Join/Join';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

const ENDPOINT = process.env.REACT_APP_BACKEND_URL;

const App = () => {
  //Do not push to github. Only for deployment.
  // For deployment to free server which turns off after certain time period. Server is pinged on application startup. Not waiting for user to login.
  useEffect(() => {
    const pingServer = async () => {
      try {
        await fetch(ENDPOINT);
      } catch (error) {
        console.error('Error:', error);
      }
    };
    pingServer();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path='/' exact element={<Join />} />
        <Route path='/chat' element={<Chat />} />
      </Routes>
    </Router>
  );
};

export default App;
